import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { ArrowRight } from "lucide-react";

const BRAND = "VOW Multi Cuisine";

const KioskEntry = () => {
  const navigate = useNavigate();
  const [room, setRoom] = useState("");
  const [error, setError] = useState("");

  const handleGo = () => {
    const r = room.trim();
    if (!r) { setError("Please enter a room number"); return; }
    if (!/^\d+$/.test(r)) { setError("Room number must be digits only"); return; }
    if (r.length > 6) { setError("Room number too long"); return; }
    // Set kiosk flag in sessionStorage before navigating
    sessionStorage.setItem("order_source", "kiosk");
    navigate(`/menu/${r}/${encodeURIComponent(BRAND)}`);
  };

  return (
    <div className="min-h-screen bg-[#1c3b2e] flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-6 pt-16 pb-8">
        <div className="text-center space-y-3 mb-10">
          <h1 className="text-5xl font-bold text-white tracking-tight">VOW</h1>
          <p className="text-sm font-medium tracking-[0.2em] text-[#bd9b5e] uppercase">Voyage of Wellness</p>
        </div>
        <div className="w-16 h-px bg-[#bd9b5e]/40 mb-10"></div>
        <div className="text-center max-w-xs">
          <h2 className="text-xl font-semibold text-white mb-2">Welcome to VOW In-Room Dining</h2>
          <p className="text-sm text-white/60 leading-relaxed">
            Enter your room number below to browse our menu and place an order
          </p>
        </div>
      </div>

      <div className="bg-[#f5f1e6] rounded-t-3xl px-6 pt-8 pb-10">
        <p className="text-sm font-medium text-[#2c2c2c] mb-4 text-center">
          Enter your room number
        </p>
        <div className="flex gap-3 max-w-xs mx-auto">
          <Input
            type="text" inputMode="numeric" pattern="[0-9]*"
            placeholder="Room No."
            value={room}
            onChange={e => { setRoom(e.target.value); setError(""); }}
            onKeyDown={e => e.key === "Enter" && handleGo()}
            className="flex-1 h-14 rounded-xl bg-white border-[#1c3b2e]/10 text-center text-2xl font-bold placeholder:text-[#2c2c2c]/25 focus-visible:ring-[#1c3b2e]"
            data-testid="kiosk-room-input"
          />
          <button
            onClick={handleGo}
            disabled={!room.trim()}
            className="h-14 w-14 rounded-xl bg-[#1c3b2e] text-white flex items-center justify-center hover:bg-[#1c3b2e]/90 disabled:opacity-30 transition-colors min-h-[44px]"
            data-testid="kiosk-go-button"
          >
            <ArrowRight className="h-6 w-6" />
          </button>
        </div>
        {error && (
          <p className="text-red-500 text-xs text-center mt-2" data-testid="kiosk-error">{error}</p>
        )}
        <p className="text-[10px] text-[#2c2c2c]/40 text-center mt-6">
          Our team will confirm your room number before delivery
        </p>
      </div>
    </div>
  );
};

export default KioskEntry;
